<template>
  <div>
    <div v-if="$i18n.locale === 'pe'">
      <Message message="" icon="coming_soon_cl.svg" :as-card="true" />
    </div>
    <div v-if="$i18n.locale === 'br'">
      <Message message="" icon="coming_soon_br.svg" :as-card="true" />
    </div>
    <div>
      <div v-if="$i18n.locale === 'cl'" id="reports-content">
        <Spinner id="spinner" :is-loading="isLoading" />
        <div id="search-bar" class="card-item mt-6">
          <div class="item-title"> Certificados SII </div>
          <FindEntitiesInput
            v-if="!isClient"
            placeholder="Encuentra certificado por nombre, RUT o email"
            is-loading="isLoading"
            :finder="finder"
            class="search-component"
            @click.native="cleanResults()"
            @select="selectedClient($event)" />
          <div v-if="documentsList.length > 0" class="report-content">
            <div
              v-for="(document, i) in documentsList"
              :key="document.Key"
              :set="metadata = getMetadata(document.Key)"
              class="card-item shadowless report-item">
              <div class="report-item-resume">
                <div class="report-item-data">
                  <div class="item-title">
                    Reporte
                  </div>
                  <div class="item-data">
                    Intereses pagados Nº 20
                  </div>
                </div>
                <div class="report-item-data">
                  <div class="item-title">
                    Periodo
                  </div>
                  <div class="item-data">
                    {{ metadata.year }}
                  </div>
                </div>
                <div class="report-item-data">
                  <div class="item-title">
                    Operación
                  </div>
                  <div class="item-data">
                    {{ metadata.companyOperationId }}
                  </div>
                </div>
                <div class="report-item-data">
                  <div class="item-title">
                    Fecha
                  </div>
                  <div class="item-data">
                    {{ dateToFormatedString(document.LastModified) }}
                  </div>
                </div>
              </div>
              <div class="report-item-download">
                <button
                  :id="`document-${i}`"
                  class="button is-button-primary is-rounded"
                  @click="downloadClientDocument(currentUser.user.clientId || clientId, document.Key)">
                  <span class="icon is-small">
                    <i class="fas fa-download" />
                  </span>
                  <span>
                    Descargar
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div v-else-if="noDocuments" class="report-no-content">
            <div class="column has-text-centered no-document-icon">
              <img src="@/ui/assets/img/document-not-found.svg">
            </div>
            <div class="no-document">
              No se encontraron documentos.
            </div>
          </div>
        </div>
        <div v-if="!isClient" id="sii-1898-block" class="card-item">
          <div class="report-content">
            <div class="item-title"> SII </div>
            <div class="card-item shadowless report-item">
              <div class="report-item-resume">
                <div class="report-item-data">
                  <div class="item-title"> Reporte </div>
                  <div class="item-data"> Declaraciones Juradas 1898 </div>
                </div>
                <div class="report-item-data">
                  <div class="item-title"> Periodo </div>
                  <div class="item-data"> 2020 </div><!--cambiar a dinámico-->
                </div>
              </div>
              <div class="report-item-download">
                <button
                  id="download-report"
                  class="button is-button-primary is-rounded"
                  @click="downloadReport('2020-76594721.txt', 'sii1898Report')">
                  <span class="icon is-small">
                    <i class="fas fa-download" />
                  </span>
                  <span class="button-title">
                    Descargar
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isClient" id="cmf-block" class="card-item">
          <div class="report-content">
            <div class="item-title"> CMF </div>
            <div class="card-item shadowless report-item">
              <div class="report-item-resume">
                <div class="report-item-data">
                  <div class="item-title"> Reporte </div>
                  <div class="item-data"> Mutuos en administración </div>
                </div>
                <div class="report-item-data">
                  <div class="item-title"> Período </div>
                  <div class="item-data"> {{ getGenerateReportDate(getCurrentDate()) }} </div>
                </div>
              </div>
              <div class="report-item-download columns is-multiline">
                <div class="two-buttons-col column">
                  <button
                    id="download-report"
                    class="button is-button-primary is-rounded"
                    @click="getAuditReportButton()">
                    <span class="icon is-small">
                      <i class="fas fa-download" />
                    </span>
                    <span class="button-title">
                      Descargar
                    </span>
                  </button>
                </div>
                <div class="two-buttons-col column">
                  <button
                    class="button is-button-secondary is-rounded"
                    aria-controls="contentIdForA11y2"
                    @click="isOpen = !isOpen">
                    <span class="button-title">
                      Ver historial
                    </span>
                  </button>
                </div>
              </div>
              <section class="cmf-list">
                <b-collapse
                  v-model="isOpen"
                  aria-id="contentIdForA11y2"
                  class="panel cmf-list"
                  animation="slide">
                  <div class="panel-block">
                    <section>
                      <b-table
                        :data="cmfDocumentList">
                        <template v-for="(column) in columns">
                          <b-table-column :key="column.id" v-bind="column">
                            <template
                              v-if="column.searchable && !column.numeric"
                              #searchable="props">
                              <b-input
                                v-model="props.filters[props.column.field]"
                                rounded
                                placeholder="Buscar por fecha"
                                icon="search"
                                size="is-small"
                                class="search-cmf" />
                            </template>
                            <template #default="props">
                              {{ props.row[column.field] }}
                            </template>
                          </b-table-column>
                        </template>
                        <b-table-column v-slot="props">
                          <template>
                            <button class="button is-button-primary is-rounded" @click="getAuditReportButton(props.row.Key)">
                              <b-icon icon="download" size="is-small" />
                              <span class="button-title">
                                Descargar
                              </span>
                            </button>
                          </template>
                        </b-table-column>
                      </b-table>
                    </section>
                  </div>
                </b-collapse>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getAuditReport, listCMFDocuments } from '@/application/services/api-clients/audit-report';
import { getClientDocument, getClientDocumentsList, findClientsBySearchString } from '@/application/services/api-clients/clients';
import { dateToFormatedString, now, dateAdd } from '@/infrastructure/date';
import Spinner from '@/ui/components/Spinner.vue';
import FindEntitiesInput from '@/ui/components/internal/FindEntitiesInput.vue';
import Message from '@/ui/components/Message.vue';

export default {
  name: 'Docs',
  components: { Spinner, FindEntitiesInput, Message },
  data() {
    return {
      isLoading: true,
      clientId: '',
      documentsList: [],
      noDocuments: false,
      passedMonth: 0,
      isOpen: false,
      cmfDocumentList: [],
      columns: [
        {
          field: 'Date',
          label: '',
          width: 700,
          searchable: true
        },
        {
          field: 'Download',
          label: '',
          width: 700,
          searchable: false
        }
      ],
      finder: findClientsBySearchString
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
    isClient() {
      return !!this.currentUser.user.clientId;
    }
  },
  watch: {
    clientId: {
      immediate: true,
      async handler(val) {
        if (!val) return;
        this.isLoading = true;
        this.documentsList = await getClientDocumentsList(val);
        this.noDocuments = this.documentsList.length === 0;
        this.isLoading = false;
      }
    }
  },
  mounted() {
    if (this.$i18n.locale === 'cl') {
      if (this.isClient) {
        this.clientId = this.currentUser.user.clientId;
      } else {
        this.isLoading = false;
      }
      this.data = this.getCMFDocumentList();
    }
  },
  methods: {
    getDateByName(Key) {
      const year = Key.substring(1, 5);
      const month = Key.substring(5, 8);
      const result = new Date(year, month - 1, 1);
      return dateToFormatedString(result, 'MMMM-YYYY');
    },
    async getCMFDocumentList() {
      const listCMFDocumentsSplit = [];
      this.cmfDocumentList = await listCMFDocuments();
      this.cmfDocumentList.forEach(element => {
        const historyReport = { Key: element.Key.split('/')[2], Date: this.getDateByName(element.Key.split('/')[2]) };
        if (historyReport.Key !== '') {
          listCMFDocumentsSplit.push(historyReport);
        }
      });
      listCMFDocumentsSplit.splice(listCMFDocumentsSplit.length - 1, 1);
      this.cmfDocumentList = listCMFDocumentsSplit;
    },
    openMenuEmit() {
      if (!this.openMenu) {
        this.$emit('openMenu', true);
        return;
      }
      this.$emit('openMenu', false);
    },
    selectedClient($event) {
      this.clientId = $event !== null ? $event._id : '';
    },
    cleanResults() {
      this.documentsList = [];
      this.noDocuments = false;
    },
    dateToFormatedString: (date, format = 'DD/MM/YYYY') => dateToFormatedString(date, format),
    getMetadata(string) {
      const data = {};
      [data.idNumber, data.year, data.companyOperationId] = string.split('.')[0].split('/');
      return data;
    },
    getCurrentDate() {
      return now('YYYY-MM-DD');
    },
    getGenerateReportDate(mCurrentDate) {
      let currentDate = mCurrentDate;
      currentDate = dateAdd(currentDate, -1, 'month');
      if (currentDate.date() < 6) {
        currentDate = dateAdd(currentDate, -1, 'month');
      }
      currentDate = dateToFormatedString(currentDate, 'MMMM-YYYY');

      return currentDate;
    },
    getAuditReportButton(filenameIn) {
      if (!filenameIn) {
        let fetchDate = now('YYYY-MM-DD');
        fetchDate = dateAdd(fetchDate, -1, 'month');
        if (fetchDate.date() < 6) {
          fetchDate = dateAdd(fetchDate, -1, 'month');
        }
        fetchDate = dateToFormatedString(fetchDate, 'YYYYMM');
        const filename = `A${fetchDate}.txt`;
        this.downloadReport(filename, 'aReport');
      } else {
        this.downloadReport(filenameIn, 'aReport');
      }
    },
    async downloadReport(filename, typeReport) {
      const result = await getAuditReport(filename, typeReport);
      const file = new Blob([result], { type: 'text/plain' });
      const fileURL = URL.createObjectURL(file);
      // Para cambiar el nombre que entrega el createObjectURL y el archivo pueda descargarse con su nombre original
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = fileURL;
      const [, name] = filename.split('-'); // para el sii que trae el año como parte del nombre
      a.download = name || filename;
      a.click();
      window.URL.revokeObjectURL(fileURL);
    },
    async downloadClientDocument(clientId, documentKey) {
      const parsedDocumentKey = documentKey.split('/').splice(1).join('-');
      const result = await getClientDocument(clientId, parsedDocumentKey);
      const blob = new Blob([result], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      window.open(url);
    }
  }
};
</script>
<style>
.card-item {
  overflow: visible;
  margin-bottom: 3rem;
}
.card-item.report-item {
  display:grid;
  grid:
    "resume button" auto
    / auto min-content;
  gap: 1rem;
  place-items: center stretch;
  padding: 1rem 2rem;
  margin: 1.5rem 0%;
}

#cmf-block .card-item.report-item {
  display:grid;
  grid:
    "resume button" auto
    "history history"
    / auto min-content;
  gap: 1rem;
  place-items: center stretch;
  padding: 1rem 2rem;
  margin: 1.5rem 0%;
}

.report-item .report-item-resume {
  display:grid;
  grid-template-columns: repeat(2, minmax(10rem, 1fr));
  gap: 1rem;
  place-items: start;
}
.report-item-resume .report-item-data {
  display: flex;
  flex-flow: row wrap;
  gap: 0rem 0.7rem;
  justify-content: center;
}
.report-item-resume{
  max-width: 600px;
}
.item-title {
  color: var(--primary);
  font-weight: 600;
  width: 100%;
}
.item-data {
  width: 100%;
}
.column.two-buttons-col {
 padding-right: 0px;
}
#search-bar {
  z-index: 9;
}
.search-component {
  margin-top: 1.5rem;
}
#spinner {
  z-index: 10;
}
.no-document {
  text-align: center;
  width: 100%;
  padding: 5px;
}
.no-document-icon img {
  margin: auto;
  max-width: 200px;
}
.cmf-list{
  box-shadow: none;
  grid-area: history;
  width: 100%;
}
.cmf-list .table tr{
  justify-content: center !important;;
}
.cmf-list .table thead th {
  border: none;
  padding: 10px 0;
}
.cmf-list .table td {
  padding: 10px 0;
  justify-content: center !important;
}
.search-cmf input{
  box-shadow: none !important;
  background-color: #EFEFEF;
}
.panel-block{
  padding: 0;
}
.panel-block section {
  width: 100%;
}
@media  (max-width: 1130px) {
  .item-title,
  .item-data,
  .button-title,
  .no-document {
    font-size: calc(1em - 0.2vw);
  }
  .report-item .report-item-resume {
  grid-template-columns: repeat(1, minmax(10rem, 1fr));
  }
}
@media  (max-width: 768px) {
  .cmf-list .table td {
    background: #EFEFEF;
    border-bottom: 0px !important;
    padding: 0;
  }
  .cmf-list .table tr{
    box-shadow: none !important;
    background: #EFEFEF !important;
    padding: 15px 0;
    border-collapse: collapse;
    border-radius: 1em;
    overflow: hidden;
  }
  .cmf-list .table thead{
    display: none;
  }
}
@media  (max-width: 520px) {
    .item-title,
  .item-data,
  .button-title,
  .no-document {
    font-size: calc(1em - 0.6vw);
  }
  .card-item.report-item {
    grid:
      "resume" auto
      "button" auto
      / auto;
    place-items: center;
    text-align: center;
  }
  #cmf-block .card-item.report-item {
    grid:
      "resume" auto
      "button" auto
      "history" auto
      / auto;
    place-items: center;
    text-align: center;
  }
  .report-item .report-item-resume {
    place-items: center;
  }
}
</style>
